<template>
    <div class="row">
        <strong>한국정보통신</strong>
        <span>{{ new Date().toLocaleDateString('ko-KR') }}</span>
    </div>
    <div class="table_row" v-if="stockprice">
        <table>
            <colgroup>
                <col style="width: 50%" />
                <col style="width: 25%" />
                <col style="width: 25%" />
            </colgroup>
            <tbody>
                <tr>
                    <th rowspan="2" :class="`price arrow ${stockprice.TBL_StockInfo.DungRak === 5 ? 'down' : 'up'}`">
                        {{ stockprice.TBL_StockInfo.CurJuka }}
                    </th>
                    <td class="bold">전일대비</td>
                    <td :class="`right ${stockprice.TBL_StockInfo.DungRak === 5 ? 'down' : 'up'} arrow`">
                        {{ stockprice.TBL_StockInfo.Debi }}
                    </td>
                </tr>
                <tr>
                    <td class="bold">등락률</td>
                    <td :class="`right ${stockprice.TBL_StockInfo.DungRak === 5 ? 'down' : 'up'}`">
                        {{ stockprice.TBL_StockInfo.DungRak === 5 ? '-' : '' }}{{ rate }}%</td>
                </tr>
            </tbody>
        </table>
        <table>
            <colgroup>
                <col style="width: 25%" />
            </colgroup>
            <thead>
                <tr>
                    <th>시가(원)</th>
                    <th>고가(원)</th>
                    <th>저가(원)</th>
                    <th>거래량(주)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="right">{{ stockprice.TBL_StockInfo.StartJuka }}</td>
                    <td class="right">{{ stockprice.TBL_StockInfo.HighJuka }}</td>
                    <td class="right">{{ stockprice.TBL_StockInfo.LowJuka }}</td>
                    <td class="right">{{ stockprice.TBL_StockInfo.Volume }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <LoadingWrap v-else />
    <div class="table_row" v-if="stockprice">
        <div class="table_col">
            <table>
                <colgroup>
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                </colgroup>
                <thead>
                    <tr>
                        <th colspan="4">KOSDAQ/전기통신업</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="bold">전일가(원)</td>
                        <td class="right">{{ stockprice.TBL_StockInfo.PrevJuka }}</td>
                        <td class="bold">매도호가(원)</td>
                        <td class="right">{{ stockprice.TBL_Hoga.medoHoka4 }}</td>
                    </tr>
                    <tr>
                        <td class="bold">전일거래량(주)</td>
                        <td class="right">{{ stockprice.TBL_DailyStock.DailyStock[0].day_Volume }}</td>
                        <td class="bold">매수호가(원)</td>
                        <td class="right">{{ stockprice.TBL_Hoga.mesuHoka0 }}</td>
                    </tr>
                    <tr>
                        <td class="bold">상한가</td>
                        <td class="right">{{ stockprice.TBL_StockInfo.UpJuka }}</td>
                        <td class="bold">52주최고(원)</td>
                        <td class="right">{{ stockprice.TBL_StockInfo.High52 }}</td>
                    </tr>
                    <tr>
                        <td class="bold">하한가</td>
                        <td class="right">{{ stockprice.TBL_StockInfo.DownJuka }}</td>
                        <td class="bold">52주최저(원)</td>
                        <td class="right">{{ stockprice.TBL_StockInfo.Low52 }}</td>
                    </tr>
                    <tr>
                        <td class="bold">액면가</td>
                        <td class="right">{{ stockprice.TBL_StockInfo.FaceJuka }}</td>
                        <td class="bold">PER</td>
                        <td class="right">{{ stockprice.TBL_StockInfo.Per }}</td>
                    </tr>
                </tbody>
            </table>
            <table>
                <colgroup>
                    <col style="width: 30%" />
                    <col style="width: 100%" />
                </colgroup>
                <thead>
                    <tr>
                        <th colspan="2">요약정보</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="bold">상장주식수(주)</td>
                        <td class="right">{{ stockprice.TBL_StockInfo.Amount }}</td>
                    </tr>
                    <tr>
                        <td class="bold">시가총액</td>
                        <td class="right">
                            {{
                                (
                                    +String(stockprice.TBL_StockInfo.Amount).replaceAll(',', '') *
                                    +String(stockprice.TBL_StockInfo.CurJuka).replaceAll(',', '')
                                ).toLocaleString('ko-KR')
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td class="bold">상장일</td>
                        <td class="right">1998년 1월 20일</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <table>
            <colgroup>
                <col width="33.33%" />
                <col width="33.33%" />
                <col width="33.33%" />
            </colgroup>
            <thead>
                <tr>
                    <th>매도잔량</th>
                    <th>호가</th>
                    <th>매수잔량</th>
                </tr>
            </thead>
            <tbody>
                <tr class="blue_bg">
                    <td class="down right">{{ stockprice.TBL_Hoga.medoJan0 }}</td>
                    <td class="right">{{ stockprice.TBL_Hoga.medoHoka0 }}</td>
                    <td></td>
                </tr>
                <tr class="blue_bg">
                    <td class="down right">{{ stockprice.TBL_Hoga.medoJan1 }}</td>
                    <td class="right">{{ stockprice.TBL_Hoga.medoHoka1 }}</td>
                    <td></td>
                </tr>
                <tr class="blue_bg">
                    <td class="down right">{{ stockprice.TBL_Hoga.medoJan2 }}</td>
                    <td class="right">{{ stockprice.TBL_Hoga.medoHoka2 }}</td>
                    <td></td>
                </tr>
                <tr class="blue_bg">
                    <td class="down right">{{ stockprice.TBL_Hoga.medoJan3 }}</td>
                    <td class="right">{{ stockprice.TBL_Hoga.medoHoka3 }}</td>
                    <td></td>
                </tr>
                <tr class="blue_bg">
                    <td class="down right">{{ stockprice.TBL_Hoga.medoJan4 }}</td>
                    <td class="right">{{ stockprice.TBL_Hoga.medoHoka4 }}</td>
                    <td></td>
                </tr>
                <tr class="red_bg">
                    <td></td>
                    <td class="right">{{ stockprice.TBL_Hoga.mesuHoka0 }}</td>
                    <td class="up right">{{ stockprice.TBL_Hoga.mesuJan0 }}</td>
                </tr>
                <tr class="red_bg">
                    <td></td>
                    <td class="right">{{ stockprice.TBL_Hoga.mesuHoka1 }}</td>
                    <td class="up right">{{ stockprice.TBL_Hoga.mesuJan1 }}</td>
                </tr>
                <tr class="red_bg">
                    <td></td>
                    <td class="right">{{ stockprice.TBL_Hoga.mesuHoka2 }}</td>
                    <td class="up right">{{ stockprice.TBL_Hoga.mesuJan2 }}</td>
                </tr>
                <tr class="red_bg">
                    <td></td>
                    <td class="right">{{ stockprice.TBL_Hoga.mesuHoka3 }}</td>
                    <td class="up right">{{ stockprice.TBL_Hoga.mesuJan3 }}</td>
                </tr>
                <tr class="red_bg">
                    <td></td>
                    <td class="right">{{ stockprice.TBL_Hoga.mesuHoka4 }}</td>
                    <td class="up right">{{ stockprice.TBL_Hoga.mesuJan4 }}</td>
                </tr>
                <tr>
                    <td class="right down">
                        {{
                            (
                                +String(stockprice.TBL_Hoga.medoJan0).replaceAll(',', '') +
                                +String(stockprice.TBL_Hoga.medoJan1).replaceAll(',', '') +
                                +String(stockprice.TBL_Hoga.medoJan2).replaceAll(',', '') +
                                +String(stockprice.TBL_Hoga.medoJan3).replaceAll(',', '') +
                                +String(stockprice.TBL_Hoga.medoJan4).replaceAll(',', '')
                            ).toLocaleString('ko-KR')
                        }}
                    </td>
                    <td class="center">총잔량</td>
                    <td class="right up">
                        {{
                            (
                                +String(stockprice.TBL_Hoga.mesuJan0).replaceAll(',', '') +
                                +String(stockprice.TBL_Hoga.mesuJan1).replaceAll(',', '') +
                                +String(stockprice.TBL_Hoga.mesuJan2).replaceAll(',', '') +
                                +String(stockprice.TBL_Hoga.mesuJan3).replaceAll(',', '') +
                                +String(stockprice.TBL_Hoga.mesuJan4).replaceAll(',', '')
                            ).toLocaleString('ko-KR')
                        }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <LoadingWrap v-else />
    <div class="table_row" v-if="stockprice">
        <table>
            <thead>
                <tr>
                    <th>일자</th>
                    <th>종가</th>
                    <th>전일대비</th>
                    <th>거래량(주)</th>
                    <th>거래대금(백만)</th>
                    <th>시가(원)</th>
                    <th>고가(원)</th>
                    <th>시가총액</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="listItem of stockprice.TBL_DailyStock.DailyStock" :key="listItem.day_Date">
                    <td class="center none-br">{{ listItem.day_Date }}</td>
                    <td class="bold center none-br">{{ listItem.day_EndPrice }}</td>
                    <td :class="`center none-br ${listItem.day_Dungrak === 5 ? 'down arrow' : 'up arrow'}`">
                        {{ listItem.day_getDebi }}
                    </td>
                    <td class="center none-br">{{ listItem.day_Volume }}</td>
                    <td class="center none-br">{{ listItem.day_getAmount }}</td>
                    <td class="center none-br">{{ listItem.day_Start }}</td>
                    <td class="center none-br">{{ listItem.day_High }}</td>
                    <td class="center none-br">
                        {{
                            (
                                +String(listItem.day_Start).replaceAll(',', '') *
                                +String(stockprice.TBL_StockInfo.Amount).replaceAll(',', '')
                            ).toLocaleString('ko-KR')
                        }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <LoadingWrap v-else />
    <div class="noti_box" v-if="stockprice">
        <p>
            본 정보는 오류가 나거나 지연될 수 있습니다. <br />
            제공된 정보에 의한 투자결과에 대한 법적인 책임을 지지않습니다.
        </p>
    </div>
    <LoadingWrap v-else />
</template>

<script>
import { getStockInfo } from '@/api';
import LoadingWrap from '../LoadingWrap.vue';

export default {
    components: {
        LoadingWrap,
    },
    data() {
        return {
            stockprice: null,
            rate: 0,
        };
    },
    async mounted() {
        const {
            data: { stockprice },
        } = await getStockInfo();
        this.stockprice = stockprice;

        this.rate =
            Math.ceil(
                (+String(stockprice.TBL_StockInfo.Debi).replaceAll(',', '') / +String(stockprice.TBL_StockInfo.PrevJuka).replaceAll(',', '')) *
                100 *
                100
            ) / 100;
    },
};
</script>

<style lang="scss" scoped>
.row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    strong {
        font-size: 18px;
        font-weight: 700;
        color: #111;
    }

    span {
        font-size: 16px;
        color: #333;
    }
}

.table_row {
    display: flex;
    gap: 60px;

    @media screen and (max-width: 1024px) {
        flex-direction: column;
    }

    .table_col {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 60px;
    }

    &+.table_row {
        margin-top: 60px;
    }

    &:nth-child(4) {
        overflow: auto;

        >table {
            min-width: 900px;
        }
    }
}

table {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #333;

    tr {
        border-bottom: 1px solid #e5e5e5;

        th {
            background: #fafafa;

            &.price {
                font-size: 50px;
                font-weight: 700;
                background: #fff;
                border-right: 1px solid #e5e5e5;

                @media screen and (max-width: 768px) {
                    font-size: 40px;
                }

                &.arrow::before {
                    width: 20px;
                    height: 20px;
                    border-top: 10px solid #0089d7;
                    border-left: 10px solid #fff;
                    border-right: 10px solid #fff;
                    margin-right: 10px;
                }

                &.up.arrow::before {
                    width: 20px;
                    height: 20px;
                    border-top: none;
                    border-bottom: 10px solid #e90000;
                    border-left: 10px solid #fff;
                    border-right: 10px solid #fff;
                    margin-right: 10px;
                }
            }
        }

        td {
            border-right: 1px solid #e5e5e5;

            &:last-child {
                border-right: none;
            }
        }

        th,
        td {
            padding: 25px 30px;
            font-size: 16px;
            line-height: 1;

            @media screen and (max-width: 1024px) {
                padding: 25px 20px;
            }

            @media screen and (max-width: 768px) {
                padding: 20px 10px;
            }
        }
    }

    .bold {
        font-weight: 700;
    }

    .left {
        text-align: left;
    }

    .right {
        text-align: right;
    }

    .center {
        text-align: center;
    }

    .down {
        color: #0089d7;

        &.arrow::before {
            content: '';
            position: relative;
            display: inline-block;
            width: 10px;
            height: 10px;
            border-top: 5px solid #0089d7;
            border-left: 5px solid #fff;
            border-right: 5px solid #fff;
            box-sizing: border-box;
            margin-right: 5px;
        }
    }

    .up {
        color: #e90000;

        &.arrow::before {
            content: '';
            position: relative;
            display: inline-block;
            width: 10px;
            height: 10px;
            border-bottom: 5px solid #e90000;
            border-left: 5px solid #fff;
            border-right: 5px solid #fff;
            box-sizing: border-box;
            margin-right: 5px;
        }
    }

    .none-br {
        border-right: none;
    }

    .blue_bg {
        td {
            background: #f5fcff;

            &:last-child {
                background: #fff;
            }
        }
    }

    .red_bg {
        td {
            background: #fef7f7;

            &:first-child {
                background: #fff;
            }
        }
    }
}

.noti_box {
    margin-top: 30px;
    border: 3px solid #fafafa;
    color: #999;
    padding: 20px 30px;

    @media screen and (max-width: 768px) {
        padding: 15px 20px;
    }

    p {
        font-size: 16px;
        line-height: 1.8;
    }
}
</style>
